import { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import icon from 'common-modules/general/assets/Desktop/images/common/btn_open_side_menu.png';
import iconBlack from 'common-modules/general/assets/Desktop/images/common/btn_open_side_menu_black.png';
import bottomIcon from 'common-modules/general/assets/Desktop/images/common/btn_open_bottom_menu.png';
import { useLocation } from 'react-router';
import MainModel from 'common-modules/general/Common/Logic/Main/MainSalesCommon';
import { toJS } from 'mobx';
import dayjs from 'dayjs';
import { observer } from 'mobx-react';
import { APIClientBaseURL } from 'common-modules/general/Config/constants';

const BackGroundContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background: #00000080;
`;

interface ContainerProps {
  isOpen: boolean;
  direction: 'right' | 'bottom';
  height?: number;
}

const bottomSlide = css`
  width: 100%;
`;

const RightSlide = css`
  width: 24.375rem;
  right: 0;
  border-left: 1px solid #eee;
`;

const ScrollbarInner = styled.div`
  padding: 0 2.5rem;
`;

const Container = styled.div<ContainerProps>`
  z-index: 999999;
  position: fixed;
  background: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;

  ${props =>
    props.direction === 'right' &&
    css`
      right: -24.375rem;
      height: 100vh;
      top: 0;
      width: 24.375rem;
      padding: 4.375rem 0;
    `}

  ${props =>
    props.direction === 'bottom' &&
    props.height &&
    css`
      width: 100%;
      bottom: -${props.height}px;
      ${ScrollbarInner} {
        padding: 2.5rem;
      }
    `}

  ${props => (props.direction === 'right' && props.isOpen ? RightSlide : '')}
  ${props =>
    props.direction === 'bottom' && props.isOpen
      ? css`
          ${bottomSlide};
          bottom: -1px;
        `
      : ''}

  transition: all 0.5s ease-in-out;
`;

const BtnWrap = styled.div<ContainerProps>`
  ${props =>
    props.direction === 'bottom' &&
    css`
      z-index: 999999;
      position: absolute;
      bottom: 100%;
      left: 50%;
      -webkit-transform: translate(-50%, 0);
      -ms-transform: translate(-50%, 0);
      transform: translate(-50%, 0);
      height: 40px;
      height: 2.5rem;
      background: #fff;
      -webkit-box-shadow: 0 -4px 5px -2px rgb(0 0 0 / 12%);
      box-shadow: 0 -4px 5px -2px rgb(0 0 0 / 12%);
      width: 100%;
      border-radius: 10px 10px 0 0;
    `}
`;

const ScrollWrapper = styled.div`
  height: 100%;
  overflow-y: auto !important;
  padding: 0 !important;
  position: relative;
  margin-right: 5px;

  &::-webkit-scrollbar {
    width: 0.1875rem;
  }
  &::-webkit-scrollbar-track {
    background: #eee;
  }
  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 8px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #c2c2c2;
  }

  @media screen and (max-width: 768px) {
    overflow-y: scroll !important;
    height: auto;
    max-height: 60vh;
    margin-right: 0;
  }
`;

const ItemContainer = styled.div`
  margin-bottom: 3.75rem;
`;

const Date = styled.div`
  margin-bottom: 10px;
  font-size: 1rem;
  font-family: 'SDGothicNeobTTF-bLt';
  color: #999;
`;

const Title = styled.div`
  font-size: 1.75rem;
  font-family: 'SDGothicNeobTTF-dMd';
  &:hover {
    color: #ff671d;
  }
`;

const Img = styled.img`
  width: 100%;
  margin-top: 15px;
`;

const Button = styled.button<ContainerProps>`
  ${props =>
    props.direction === 'right' &&
    css`
      word-break: break-all;
      text-align: center;
      position: absolute;
      right: 100%;
      padding: 10px 10px;
      padding: 0.625rem 0.625rem;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      top: 50%;
      -webkit-transform: translate(0, -50%);
      -ms-transform: translate(0, -50%);
      transform: translate(0, -50%);
      -webkit-transition: padding 0.3s;
      -o-transition: padding 0.3s;
      transition: padding 0.3s;
      cursor: pointer;
      outline: 0;
      line-height: 1;
    `}

  ${props =>
    props.direction === 'bottom' &&
    css`
      width: 100%;
      height: 100%;
      bottom: -1px;
      left: 50%;
      font-size: 0;
      outline: 0;
      -webkit-transition: -webkit-transform 0.3s;
      transition: -webkit-transform 0.3s;
      -o-transition: transform 0.3s;
      transition: transform 0.3s;
      transition: transform 0.3s, -webkit-transform 0.3s;
    `}
`;

const Link = styled.a<{ isLink: boolean }>`
  cursor: ${props => (props.isLink ? 'pointer' : 'default')};
  font-size: 1.75rem;
  font-family: 'SDGothicNeobTTF-dMd';
  &:hover {
    color: ${props => (props.isLink && '#ff671d')};
    font-size: 1.75rem;
    font-family: 'SDGothicNeobTTF-dMd';
  }
`;

interface IProps extends ContainerProps {
  isTouched: boolean;
}

const I = styled.i<IProps>`
  ${props =>
    props.direction === 'right' &&
    props.isOpen &&
    css`
      transform: ${props.isOpen ? `rotate(180deg)` : `rotate(0deg)`};
    `}

  ${props =>
    props.direction === 'right' &&
    css`
      display: inline-block;
      width: 0.8125rem;
      height: 1.125rem;
      background: url(${props.isTouched ? iconBlack : icon});
      background-position: center;
      background-size: 13px 18px;

      -webkit-transition: -webkit-transform 0.3s;
      transition: -webkit-transform 0.3s;
      -o-transition: transform 0.3s;
      transition: transform 0.3s;
      transition: transform 0.3s, -webkit-transform 0.3s;
    `}

  ${props =>
    props.direction === 'bottom' &&
    css`
      width: 15px;
      width: 0.9375rem;
      height: 9px;
      height: 0.5625rem;
      background: url(${bottomIcon}) no-repeat 0 0;
      display: inline-block;
      background-size: 15px 9px;
    `}

    ${props =>
    props.direction === 'bottom' &&
    props.isOpen &&
    css`
      transform: ${props.isOpen ? `rotate(180deg)` : `rotate(0deg)`};
    `}
`;

interface Props {
  direction: 'right' | 'bottom';
  mainModel: MainModel;
}

const NoticeBurgerMenu = observer(({ direction, mainModel }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isTouched, setIsTouched] = useState<boolean>(false);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const containerElement = document.getElementById('notice-burger-menu');

    if (containerElement) {
      setHeight(containerElement.clientHeight);
    }
  });

  const noticeItemList = toJS(mainModel.mainData.data?.sideBanner);

  const location = useLocation();

  const scrollEvent = () => {
    const scrollY = window.scrollY ?? window.pageYOffset;

    const salesHeader = document.getElementsByClassName('sales-header');
    const topBanner = document.getElementById('top-banner');
    const button = document.getElementById('burger-menu-button');

    if (topBanner) {
      if (salesHeader?.[0] && button) {
        const salesHeaderHeight = salesHeader[0].clientHeight;
        const topbannerHeight = topBanner?.clientHeight;

        if (
          salesHeaderHeight + topbannerHeight - document.body.scrollHeight <
          button?.offsetTop - button.clientHeight / 2 + scrollY - document.body.scrollHeight
        ) {
          setIsTouched(true);
        } else {
          setIsTouched(false);
        }
      }
    } else {
      if (salesHeader?.[0] && button) {
        const salesHeaderHeight = salesHeader[0].clientHeight;

        if (
          salesHeaderHeight - document.body.scrollHeight <
          button?.offsetTop - button.clientHeight / 2 + scrollY - document.body.scrollHeight
        ) {
          setIsTouched(true);
        } else {
          setIsTouched(false);
        }
      }
    }
  };

  useEffect(() => {
    scrollEvent();
    document.addEventListener('scroll', scrollEvent);

    return () => {
      document.removeEventListener('scroll', scrollEvent);
    };
  });

  const handleClickIcon = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    const isHashRoot = hash === '/sales/' || hash === '/';

    if (isHashRoot) {
      setIsOpen(true);
      setTimeout(() => { setIsOpen(false); }, 3000);
    } else {
      setIsOpen(false);
    }
  }, [location.hash]);

  const handleClickItem = (url: string, isOpenNewTab: string) => {
    if (isOpenNewTab === 'Y') {
      window.open(url, '_blank');
    } else {
      window.open(url, '_self');
    }
  };

  const renderItems = () => {
    return (
      noticeItemList &&
      noticeItemList.map(item => {
        return (
          <ItemContainer key={item.cntsBanr}>
            {/* 
                2023-03-02 chaikm
                기존 날짜 dateBanr(YYYYMMDD) -> dntRgst(YYYY-MM-DDTHH:mm:ss) 
            */}
            <Date className="date">{dayjs(item.dntRgst, 'YYYY-MM-DDTHH:mm:ss').format('YYYY.MM.DD')}</Date>
            {/* <Title className="title">{item.nmBanr}</Title> */}
            <Link className="title" isLink={item.urlMvmt !== ''} onClick={() => handleClickItem(item.urlMvmt, item.ynNewwdw)}>{item.nmBanr}</Link>
            {item.typeOpn === '1' && <Img className="img" src={`${APIClientBaseURL.file}${item.sralAtchPcFile}`}></Img>}

          </ItemContainer>
        );
      })
    );
  };

  if (!noticeItemList || (noticeItemList && noticeItemList.length === 0)) {
    return null;
  } else
    return (
      <>
        {direction === 'bottom' && isOpen && <BackGroundContainer />}

        <Container isOpen={isOpen} direction={direction} height={height}>
          <BtnWrap isOpen={isOpen} direction={direction}>
            <Button isOpen={isOpen} direction={direction} onClick={handleClickIcon} id={'burger-menu-button'}>
              <I direction={direction} isOpen={isOpen} isTouched={isTouched} />
            </Button>
          </BtnWrap>
          <ScrollWrapper id="notice-burger-menu">
            <ScrollbarInner>{renderItems()}</ScrollbarInner>
          </ScrollWrapper>
        </Container>
      </>
    );
});

export default NoticeBurgerMenu;
